import { roomsToQueryParams } from '../utils/roomsToQueryParams';
import { formatSearchDate } from '../utils/formatSearchDate';
import type { HotelAutocompleteOption } from '../../../hotel/HotelSearchForm';
import { createWhitelabelUrl } from '../../../hotel/kayakWhitelabel';
import type { HotelRoom } from '../types/HotelRoom';

type Props = {
    destinationContext?: HotelAutocompleteOption;
    startDate?: Date;
    endDate?: Date;
    rooms: HotelRoom[];
    unleash?: Record<string, boolean> | null; // cannot be just undefined as that is not serializable (toggles are returned from getSSP)
};

export const HotelHiddenInputs = ({ destinationContext, startDate, endDate, rooms, unleash }: Props) => {
    const checkInDate = formatSearchDate(startDate);
    const checkOutDate = formatSearchDate(endDate);
    const showDate = destinationContext?.searchable && !!checkInDate && !!checkOutDate;

    if (unleash?.kayakWhitelabel) {
        return (
            <input
                data-testid="whiteLabelUrl"
                type="hidden"
                name="url"
                value={createWhitelabelUrl(destinationContext, startDate, endDate, rooms)}
            />
        );
    }

    return (
        <>
            {showDate && (
                <>
                    <input type="hidden" name="checkInDate" value={checkInDate} />
                    <input type="hidden" name="checkOutDate" value={checkOutDate} />
                </>
            )}
            {destinationContext?.searchable &&
                roomsToQueryParams(rooms).map((roomStr, index) => (
                    <input key={`room-${index}-${roomStr}`} type="hidden" name={`rooms[${index}]`} value={roomStr} />
                ))}
        </>
    );
};
